<div class="flex flex-col gap-5">
  <!-- Coordonnées & Adresse de réception (fond blanc card) -->
  @if (resolvedAddress(); as addr) {
    <div
      class="p-4 bg-white dark:bg-neutral-2 rounded-2xl border border-neutral-3 dark:border-neutral-4 shadow-xs flex flex-col sm:flex-row sm:items-center justify-between gap-3"
    >
      <div class="flex items-start gap-3 min-w-0">
        <div
          class="w-10 h-10 rounded-xl bg-primary-2 text-primary-11 flex items-center justify-center shrink-0 mt-0.5"
        >
          <mat-icon class="!w-5 !h-5 !text-xl">place</mat-icon>
        </div>
        <div class="flex flex-col min-w-0">
          <div class="flex items-center gap-2 flex-wrap">
            <span class="text-sm font-bold text-neutral-12">{{ addr.line1 }}</span>
            <span
              class="text-[10px] font-semibold px-2 py-0.5 rounded-full border shadow-2xs"
              [class.bg-primary-2]="!addr.isCustom"
              [class.text-primary-11]="!addr.isCustom"
              [class.border-primary-4]="!addr.isCustom"
              [class.bg-neutral-2]="addr.isCustom"
              [class.text-neutral-10]="addr.isCustom"
              [class.border-neutral-3]="addr.isCustom"
            >
              {{ addr.sourceLabel }}
            </span>
          </div>
          @if (addr.complement) {
            <span class="text-xs text-neutral-10">{{ addr.complement }}</span>
          }
          <span class="text-xs text-neutral-10 font-medium">{{ addr.line2 }}</span>
        </div>
      </div>

      @if (mapsUrl()) {
        <a
          [href]="mapsUrl()!"
          target="_blank"
          rel="noopener noreferrer"
          class="inline-flex items-center gap-1.5 px-3.5 py-1.5 text-xs font-semibold text-primary-11 bg-primary-2 hover:bg-primary-3 border border-primary-4 rounded-xl transition-all shrink-0 cursor-pointer self-start sm:self-auto shadow-2xs"
        >
          <mat-icon class="!w-3.5 !h-3.5 !text-sm">directions</mat-icon>
          <span>Itinéraire</span>
        </a>
      }
    </div>
  } @else {
    <div
      class="p-6 text-center border-2 border-dashed border-neutral-3 dark:border-neutral-4 rounded-2xl bg-white dark:bg-neutral-2 shadow-xs max-w-full"
    >
      <p class="text-xs text-neutral-9 italic">Aucune adresse professionnelle renseignée.</p>
    </div>
  }

  <!-- Horaires d'ouverture -->
  <aura-opening-hours-display [hours]="resolvedHours()" />
</div>
